// removed by extract-text-webpack-plugin
module.exports = {"list":"list___2hDom","item":"item___2sH5s","meta":"meta___BV4a5","avatar":"avatar___pIwL0","read":"read___pmvzr","title":"title___1kgPc","description":"description___1j-CC","datetime":"datetime___3Lc_N","extra":"extra___EiGs2","notFound":"notFound___qqrrt","clear":"clear___sjDKE"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NoticeIcon/NoticeList.less
// module id = 436
// module chunks = 0 1